/* eslint-disable */
/// This file is auto generated - do not edit manually
export const ConnectedContentPDPHeading = 'Website.Recommendation.ConnectedContentPDPHeading';
export const ShowMore = 'Website.Recommendation.ShowMore';
